import React from "react";
import Latex from "react-latex-next";
import { Button } from "react-bootstrap";
import { ZoomImage } from "../ZoomImage/ZoomImage";
import { Question } from "../../types";

type SjtAnswerListProps = {
  question: Question;
  practiceQuestionAnswered: boolean;
  selection: number[];
  initialLetterByAnswerId: { [key: number]: string };
  delimeters: any[];
  onOptionClick: (answerOptionId: number) => void;
  onClear: () => void;
  onSubmit: () => void;
  hideSubmitButton?: boolean;
  hideClearButton?: boolean;
};

export const SjtAnswerList: React.FC<SjtAnswerListProps> = ({
  question,
  practiceQuestionAnswered,
  selection,
  initialLetterByAnswerId,
  delimeters,
  onOptionClick,
  onClear,
  onSubmit,
  hideSubmitButton,
  hideClearButton,
}) => {
  return (
    <div style={{ width: "100%" }}>
      <div
        className="answer-options-wrapper"
        style={{ display: "flex", flexDirection: "column", gap: 12, maxWidth: 760, marginBottom: 16 }}
      >
        {question.answerOptions.map((answerOption) => {
          const option = initialLetterByAnswerId[answerOption.id];
          const selectedIndex = selection.indexOf(answerOption.id);
          const isSelected = selectedIndex >= 0;
          const classes = ["answer-option"] as string[];
          if (practiceQuestionAnswered) {
            classes.push("locked");
          }
          return (
            <div
              className={classes.join(" ")}
              id={answerOption.id.toString()}
              onClick={() => {
                if (!isSelected) onOptionClick(answerOption.id);
              }}
              style={{
                userSelect: "none",
                padding: "10px 14px",
                transition: "all 150ms ease",
                display: "flex",
                alignItems: "flex-start",
                gap: 12,
                cursor: practiceQuestionAnswered || isSelected ? "default" : "pointer",
                backgroundColor: isSelected ? "#f5f9ff" : undefined,
                border: "1px solid transparent",
                borderColor: isSelected ? "#d6e6ff" : "transparent",
                // borderRadius: isSelected ? 8 : undefined,
                outline: isSelected ? "none" : undefined,
              }}
            >
              <div
                style={{
                  minWidth: 28,
                  height: 28,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #e0e0e0",
                  borderRadius: 6,
                  fontWeight: 600,
                  lineHeight: 1,
                  marginTop: 2,
                }}
              >
                {option}
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ marginBottom: 6 }}>
                  <Latex delimiters={delimeters}>{answerOption.text}</Latex>
                </p>
                {answerOption.imageUrl && (
                  <ZoomImage src={answerOption.imageUrl} width={180}></ZoomImage>
                )}
              </div>
              <div
                style={{
                  minWidth: 28,
                  height: 28,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid #e0e0e0",
                  borderRadius: 6,
                  fontWeight: 600,
                  lineHeight: 1,
                  marginTop: 2,
                  visibility: isSelected ? "visible" : "hidden",
                }}
              >
                {selectedIndex + 1}
              </div>
            </div>
          );
        })}
        <div
          style={{
            marginTop: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {hideClearButton ? null : (
              <Button
                variant="danger"
                style={{
                  display:
                    practiceQuestionAnswered || selection.length === 0
                      ? "none"
                      : "inline-block",
                }}
                onClick={onClear}
              >
                Clear
              </Button>
            )}
            {hideSubmitButton ? null : (
              <Button
                style={{
                  display: practiceQuestionAnswered ? "none" : "inline-block",
                }}
                onClick={onSubmit}
              >
                Submit answer
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};


